import React, { useEffect, useState } from "react";
import styles from "./BrownfieldFilter.module.scss";
import config from "../../assets/config.json";
import switchStyles from "../CleanupsFilter/CleanupsFilter.module.scss";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils.js";
import { CalciteBlock, CalciteButton, CalciteCheckbox, CalciteLabel, CalciteSwitch } from "@esri/calcite-components-react";

let queryStatusParams: Array<any> = [];
let queryTypeParams: Array<any> = [];
let toggleOrClear: string = "clear";
let filteringIsSpecific: boolean = false;
let grantTypeNameArray: Array<string> = [];
const BrownfieldFilter = (props) => {
  const [filteringBrownfields, setFilteringBrownfields] = useState<boolean>(false);
  const [grantTypeDivArray, setGrantTypeDivArray] = useState<Array<any>>([]);
  const [grantStatusDivArray, setGrantStatusDivArray] = useState<Array<any>>(
    []
  );
  // const [grantTypeNameArray, setGrantTypeNameArray] = useState<Array<any>>([]);
  // const brownfieldLayer = props.webmap.layers.find(

  //   (e) => e.title === config.layerNames.brownfieldLayer.title

  //   );
  const brownfieldLayer = props.webmap.layers
    .find(
      (e) =>
        e.allLayers &&
        e.allLayers.items.find(
          (p: any) => p.title === config.layerNames.brownfieldLayer.title
        )
    )
    .allLayers.items.find(
      (p: any) => p.title === config.layerNames.brownfieldLayer.title
    );
  const [brownfieldLayerView, setBrownfieldLayerView] = useState<any>(null);

  // triggered when the clear all button is clicked
  const clearAll = () => {
    // reset the brownfield layer view
    filteringIsSpecific = false;
    brownfieldLayerView.filter = { where: "1=0" };
    brownfieldLayer.visible = false;
    toggleOrClear = "clear";
    // rerender the component with blank checkboxes
    createTypeCheckBoxes(grantTypeNameArray, false);
    setGrantStatusDivArray(createStatusCheckBoxes(false));
  };

  // triggered when the toggle all button is clicked
  const toggleAll = () => {
    // rerender the component with checked checkboxes
    filteringIsSpecific = false;
    brownfieldLayerView.filter = { where: "1=1" };
    brownfieldLayer.visible = true;
    toggleOrClear = "toggle";
    createTypeCheckBoxes(grantTypeNameArray, true);
    setGrantStatusDivArray(createStatusCheckBoxes(true));
  };

  // triggered every time a grant type checkbox is clicked
  // adds the grant type to the array of grant types to query if checked is true, removes it otherwise
  const grantTypeToggler = (grantType) => {
    let tempArr = Array<any>();
    let alreadyInParams = false;
    queryTypeParams.forEach((value) => {
      if (value === grantType) {
        alreadyInParams = true;
      } else if (value !== grantType) {
        tempArr.push(value);
      }
    });
    if (alreadyInParams === false) {
      tempArr.push(grantType);
    }
    queryTypeParams = tempArr;
  };

  // triggered every time a grant status checkbox is clicked
  // adds the grant status to the array of grant statuses to query if checked is true, removes it otherwise
  const statusTypeToggler = (status) => {
    let tempArr = Array<any>();
    let alreadyInParams = false;
    queryStatusParams.forEach((value) => {
      if (value === status) {
        alreadyInParams = true;
      } else if (value !== status) {
        tempArr.push(value);
      }
    });
    if (alreadyInParams === false) {
      tempArr.push(status);
    }
    queryStatusParams = tempArr;
  };

  // triggered when the filter button is clicked
  // retrieves the relevant object ids from the table,
  // then uses those object ids to get the relevant object ids from the brownfield layer
  // and toggles their visibility on the layer
  const filterClick = async () => {
    filteringIsSpecific = true;
    setFilteringBrownfields(true);
    // set the Brownfields layer to visible
    if (brownfieldLayerView.visible === false) {
      brownfieldLayer.visible = true;
    }
    let objectIdsFromTable: Array<Number> = await tableQueryFunction(false);
    if (objectIdsFromTable.length > 0) {
      brownfieldLayerView.filter = {
        where: `JURISDICTION_ID IN (${objectIdsFromTable.join(", ")})`,
      };
      reactiveUtils.when(
        () => brownfieldLayerView.updating === false,
        () => {
          brownfieldLayer.visible = true;
        },
        {
          once: true,
        }
      );
    } else {
      brownfieldLayer.visible = false;
      // filteringIsSpecific = false;
    }
    setFilteringBrownfields(false);
  };

  // get the relevant tuples from the brownfield table to query the brownfield layer for
  const tableQueryFunction = async (toggleAll?) => {
    const brownfieldTable = getGrantTable();
    let allParamStr: string = "";
    if (toggleAll) {
      allParamStr = "1=1";
    } else {
      const statusParamStr =
        queryStatusParams.length > 0
          ? `GRANT_STATUS = '` +
            queryStatusParams.join(`' OR GRANT_STATUS = '`) +
            `'`
          : "";
      const typeParamStr =
        queryTypeParams.length > 0
          ? `GRANT_TYPE = '` + queryTypeParams.join(`' OR GRANT_TYPE = '`) + `'`
          : "";
      allParamStr =
        typeParamStr.length > 0
          ? statusParamStr + " OR " + typeParamStr
          : statusParamStr;
      // remove preceding ' OR' that will be at start of string if statusParamStr is empty
      if (allParamStr.slice(0, 3) === " OR") {
        allParamStr = allParamStr.substring(3);
      }
    }
    let needAnotherQuery = true;
    let startingFeature = 0;
    const maxRecordCount = brownfieldTable.capabilities.query.maxRecordCount;
    const tableQueryArray: Array<Number> = [];
    while (needAnotherQuery === true) {
      const newQuery = brownfieldTable.createQuery();
      newQuery.start = startingFeature;
      newQuery.num = maxRecordCount;
      newQuery.where = allParamStr.length > 0 ? allParamStr : "1=0";
      newQuery.outFields = ["JURISDICTION_ID"];
      newQuery.returnDistinctValues = true;
      newQuery.returnGeometry = false;
      const newQueryResults = await brownfieldTable.queryFeatures(newQuery);
      newQueryResults.features.forEach((feature) => {
        tableQueryArray.push(feature.attributes.JURISDICTION_ID);
      });
      if (newQueryResults.exceededTransferLimit === true) {
        startingFeature = tableQueryArray.length - 1;
      } else {
        needAnotherQuery = false;
      }
    }
    return tableQueryArray;
  };

  // retrieve the table layer from the webmap
  const getGrantTable = () => {
    let brownfieldTable;
    props.webmap.tables.forEach((table) => {
      if (table.title === config.tableNames.brownfieldTable.title) {
        brownfieldTable = table;
      }
    });
    return brownfieldTable;
  };

  // get list of filter types from the table
  async function getFilterByTypeList(brownfieldTable) {
    let initialGrants: Array<any> = [];
    let revisedGrants: Array<any> = [];
    let query = brownfieldTable.createQuery();
    query.where = "JURISDICTION_ID > 0";
    query.outFields = "GRANT_TYPE";
    query.returnDistinctValues = true;
    let result = await brownfieldTable.queryFeatures(query).catch((e) => {
      console.error("error occured during query! error:", e);
    });
    initialGrants = result.features;
    initialGrants.forEach((grant) => {
      if (grant.attributes.GRANT_TYPE !== null) {
        revisedGrants.push(grant);
      }
    });
    // setGrantTypeNameArray(revisedGrants);
    grantTypeNameArray = revisedGrants;
    return revisedGrants;
  }

  // create the checkboxes for the filter type section
  const createTypeCheckBoxes = (arrayOfGrantTypes, checkAll: boolean) => {
    let checkDivs = new Array<any>();
    // create the array of divs for component load or when clear button is hit
    if (!checkAll) {
      queryTypeParams = [];
      arrayOfGrantTypes.forEach((grantType) => {
        checkDivs.push(
          <div className={styles.GrantTypeFilterDivs} key={Math.random()}>
            <CalciteCheckbox
              className={styles.titlesAndCheckboxes}
              name={grantType.attributes.GRANT_TYPE + " checkbox"}
              onClick={() => {
                grantTypeToggler(grantType.attributes.GRANT_TYPE);
              }}
            />
            <CalciteLabel className={styles.titles}>
              {grantType.attributes.GRANT_TYPE}
            </CalciteLabel>
          </div>
        );
      });
    } else if (checkAll) {
      let tempParams = new Array<any>();
      arrayOfGrantTypes.forEach((grantType) => {
        tempParams.push(grantType.attributes.GRANT_TYPE);
        checkDivs.push(
          <div className={styles.GrantTypeFilterDivs} key={Math.random()}>
            <CalciteCheckbox
              checked
              className={styles.titlesAndCheckboxes}
              name={grantType.attributes.GRANT_TYPE + " checkbox"}
              onClick={() => {
                grantTypeToggler(grantType.attributes.GRANT_TYPE);
              }}
            />
            <CalciteLabel className={styles.titles}>
              {grantType.attributes.GRANT_TYPE}
            </CalciteLabel>
          </div>
        );
      });
      queryTypeParams = tempParams;
    }
    setGrantTypeDivArray(checkDivs);
    return checkDivs;
  };

  // create the checkboxes for the status section
  const createStatusCheckBoxes = (checkAll: boolean) => {
    if (checkAll) {
      let statusDivs = new Array<any>();
      queryStatusParams = ["Open", "Closed", "Cancelled", "4", "Post-Closeout"];
      statusDivs.push([
        <div
          className={styles.GrantTypeFilterDivs}
          key={"statusCheck-" + Math.random()}
        >
          <CalciteCheckbox
            checked={true}
            className={styles.titlesAndCheckboxes}
            name={"Open"}
            onCalciteCheckboxChange={() => {
              statusTypeToggler("Open");
            }}
          />
          <CalciteLabel className={styles.titles}>{"Open"}</CalciteLabel>
        </div>,
        <div
          className={styles.GrantTypeFilterDivs}
          key={"statusCheck-" + Math.random()}
        >
          <CalciteCheckbox
            checked={true}
            className={styles.titlesAndCheckboxes}
            name={"Closed"}
            onCalciteCheckboxChange={() => {
              statusTypeToggler("Closed");
            }}
          />
          <CalciteLabel className={styles.titles}>{"Closed"}</CalciteLabel>
        </div>,
        <div
          className={styles.GrantTypeFilterDivs}
          key={"statusCheck-" + Math.random()}
        >
          <CalciteCheckbox
            checked={true}
            className={styles.titlesAndCheckboxes}
            name={"Cancelled"}
            onCalciteCheckboxChange={() => {
              statusTypeToggler("Cancelled");
            }}
          />
          <CalciteLabel className={styles.titles}>{"Cancelled"}</CalciteLabel>
        </div>,
        <div
          className={styles.GrantTypeFilterDivs}
          key={"statusCheck-" + Math.random()}
        >
          <CalciteCheckbox
            checked={true}
            className={styles.titlesAndCheckboxes}
            name={"Other"}
            onCalciteCheckboxChange={() => {
              statusTypeToggler("4");
            }}
          />
          <CalciteLabel className={styles.titles}>{"Other"}</CalciteLabel>
        </div>,
        <div
          className={styles.GrantTypeFilterDivs}
          key={"statusCheck-" + Math.random()}
        >
          <CalciteCheckbox
            checked={true}
            className={styles.titlesAndCheckboxes}
            name={"Post-Closeout"}
            onCalciteCheckboxChange={() => {
              statusTypeToggler("Post-Closeout");
            }}
          />
          <CalciteLabel className={styles.titles}>{"Post-Closeout"}</CalciteLabel>
        </div>,
      ]);
      return statusDivs;
    } else {
      queryStatusParams = [];
      let statusDivs = new Array<any>();
      statusDivs.push([
        <div
          className={styles.GrantTypeFilterDivs}
          key={"statusCheck-" + Math.random()}
        >
          <CalciteCheckbox
            className={styles.titlestitlesAndCheckboxes}
            name={"Open"}
            onCalciteCheckboxChange={() => {
              statusTypeToggler("Open");
            }}
          />
          <CalciteLabel className={styles.titles}>{"Open"}</CalciteLabel>
        </div>,
        <div
          className={styles.GrantTypeFilterDivs}
          key={"statusCheck-" + Math.random()}
        >
          <CalciteCheckbox
            className={styles.titlesAndCheckboxes}
            name={"Closed"}
            onCalciteCheckboxChange={() => {
              statusTypeToggler("Closed");
            }}
          />
          <CalciteLabel className={styles.titles}>{"Closed"}</CalciteLabel>
        </div>,
        <div
          className={styles.GrantTypeFilterDivs}
          key={"statusCheck-" + Math.random()}
        >
          <CalciteCheckbox
            className={styles.titlesAndCheckboxes}
            name={"Cancelled"}
            onCalciteCheckboxChange={() => {
              statusTypeToggler("Cancelled");
            }}
          />
          <CalciteLabel className={styles.titles}>{"Cancelled"}</CalciteLabel>
        </div>,
        <div
          className={styles.GrantTypeFilterDivs}
          key={"statusCheck-" + Math.random()}
        >
          <CalciteCheckbox
            className={styles.titlesAndCheckboxes}
            name={"Other"}
            onCalciteCheckboxChange={() => {
              statusTypeToggler("4");
            }}
          />
          <CalciteLabel className={styles.titles}>{"Other"}</CalciteLabel>
        </div>,
        <div
          className={styles.GrantTypeFilterDivs}
          key={"statusCheck-" + Math.random()}
        >
          <CalciteCheckbox
            className={styles.titlesAndCheckboxes}
            name={"Post-Closeout"}
            onCalciteCheckboxChange={() => {
              statusTypeToggler("Post-Closeout");
            }}
          />
          <CalciteLabel className={styles.titles}>{"Post-Closeout"}</CalciteLabel>
        </div>,
      ]);
      return statusDivs;
    }
  };

  // sets the grantTypeNameArray and creates the grant type checkboxes
  const buildFilterByGrantType = async () => {
    let grants = await getFilterByTypeList(getGrantTable());
    // setGrantTypeNameArray(grants);
    grantTypeNameArray = grants;
    createTypeCheckBoxes(grants, false);
  };

  useEffect(() => {}, [
    grantTypeDivArray,
    grantStatusDivArray,
    brownfieldLayerView,
  ]);

  useEffect(() => {
    getGrantTable();
    buildFilterByGrantType();
    setGrantStatusDivArray(createStatusCheckBoxes(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [hasWatchers, setHasWatchers] = useState<boolean>(false);
  useEffect(() => {
    if (brownfieldLayerView === null) {
      props.view.when(async () => {
        await props.view.whenLayerView(brownfieldLayer).then((layerView) => {
          setBrownfieldLayerView(layerView);
        });
      });
    }
  });

  useEffect(() => {
    if (!hasWatchers && brownfieldLayerView !== null) {
      reactiveUtils.when(
        () => brownfieldLayer.visible,
        () => {
          brownfieldLayerView.visible = true;
          if (filteringIsSpecific === false) {
            toggleAll();
          }
          filteringIsSpecific = false;
        }
      );
      reactiveUtils.when(
        () => !brownfieldLayer.visible,
        () => {
          brownfieldLayerView.visible = false;
          if (filteringIsSpecific === false) {
            clearAll();
          }
          filteringIsSpecific = false;
        }
      );
      setHasWatchers(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasWatchers, brownfieldLayerView]);

  useEffect(() => {}, [grantTypeDivArray, grantStatusDivArray]);

  return (
    <div className={styles.BrownfieldFilter}>
      <CalciteBlock
        heading={"Brownfield Grants"}
        description={"See filter options for Brownfield Grant jurisdictions - please be sure to click the blue Filter button after making changes to the checkbox selections"}
        collapsible
        open
      >
        <div className={styles.controlsDiv}>
          <CalciteButton
            onClick={() => {
              filterClick();
            }}
            {...(filteringBrownfields ? {loading: true} : {})}
            iconStart={"layer-filter"}
          >
            Filter
          </CalciteButton>

          <div className={switchStyles.toggleSwitchDiv}>
            <label className={switchStyles.toggleLabel}>
              Toggle All Grants
            </label>
            {toggleOrClear === "toggle" && (
              <CalciteSwitch
                checked
                onCalciteSwitchChange={() => {
                  clearAll();
                }}
              />
            )}
            {toggleOrClear === "clear" && (
              <CalciteSwitch
                onCalciteSwitchChange={() => {
                  toggleAll();
                }}
              />
            )}
          </div>
        </div>
        <CalciteBlock
          heading={"Type of grant"}
          description={"Toggle which types of grants to filter"}
          open
        >
          {grantTypeDivArray}
        </CalciteBlock>

        <CalciteBlock
          heading="Grant Status"
          description={"Filter by grant status"}
          open
        >
          {grantStatusDivArray}
        </CalciteBlock>
      </CalciteBlock>
    </div>
  );
};

export default BrownfieldFilter;
